import React from 'react'

const DomainContext = React.createContext({domain:"", domain_name: "", loadingdomain:true, domain_data:{}, licence_status:false})

export default DomainContext 